import AnalyticsV3 from './Tracking/AnalyticsV3';
import AnalyticsV4 from './Tracking/AnalyticsV4';
import FacebookPixel from './Tracking/FacebookPixel';
import Ahoy from './Tracking/Ahoy';


// TODO: Subtle change: getExtraParams are now called during tracker creation instead of after startTracking
// (previously initAnalytics) is called, we should verify that they are available
const getExtraParams = () => {
  /* Our mobile apps */
  if ('RestaumaticMobileApp' in window) {
    return { "campaignSource": "mobile_app", "campaignMedium": "mobile_app" };
  /* External apps (not belonging to us) */
  } else if ('RestaumaticAnalytics' in window) {
    return JSON.parse(window.RestaumaticAnalytics.getExtraParams());
  } else {
    return {}
  }
}



function init() {
  const config = Skubacz.configuration.tracking;

  const trackers = [];
  const extraParams = getExtraParams();

  trackers.push(Ahoy.createTracker(config));
  Object.entries(config.analyticsV4).forEach(function ([k, v]) {
    trackers.push(AnalyticsV4.createTracker(k, v, config, extraParams))
  });
  Object.entries(config.analyticsV3).forEach(function ([k, v]) {
    trackers.push(AnalyticsV3.createTracker(k, v, config, extraParams))
  });
  if (config.facebookPixelId) {
    trackers.push(FacebookPixel.createTracker(config.facebookPixelId, config));
  }

  function withTrackers(f) {
    trackers.forEach(function (tracker) {
      f(tracker);
    });
  }

  $(document).on('click.ga-event.data-api', "[data-ga-action]", function (){
    var item = $(this);
    withTrackers(function (tracker) {
      var action = item.data('ga-action');
      var optLabel = item.data('ga-label');
      var optValue = item.data('ga-value');
      tracker.customEvent({ action: action, optLabel: optLabel, optValue: optValue });
    });
  });

  var _onError = window.onerror;
  window.onerror = function (message, source, lineno, colno, exception) {
    // NB: we now send it to all trackers (even non restaumatic ones)
    withTrackers(function (tracker) {
      tracker.onError(message);
    })
    if (_onError) {
      _onError.apply(window, arguments);
    }
  };

  return {
    startTracking: function(clientId) {
      withTrackers(function (tracker) {
        tracker.init(clientId);
        tracker.pageView(config.viewName)
      });
    },
    trackNamedEvent: function (event) {
      withTrackers(function (tracker) {
        tracker.standardEvent(event);
      });
    }
  }
}
export default { init };
